export const required = (value) => {
  if (typeof value === "undefined" || value === "") {
    return {
      hasError: false,
      errorMessage: "وارد کردن مقدار برای این فیلد اجباری است",
    };
  } else if (typeof value === "number" || typeof value === 'object' || typeof value === "boolean") {
    return {
      hasError: true,
      errorMessage: "",
    };    
  } else {
    return {
      hasError: value.trim() !== "",
      errorMessage:
        value.trim() !== "" ? "وارد کردن مقدار برای این فیلد اجباری است" : "",
    };    
  }
}

export const length = config => value => {
  let isValid = true;
  let errorMessage = "";
  if (config.min) {
    isValid = isValid && value.trim().length >= config.min;
    !isValid && (errorMessage = "نمی‌تواند کوتاه‌تر از "+config.min+" کاراکتر باشد");
  }
  if (config.max) {
    isValid = isValid && value.trim().length <= config.max;
    !isValid && (errorMessage = "نمی‌تواند طولانی‌تر از "+config.max+" کاراکتر باشد");
  }
  return {
    hasError: isValid,
    errorMessage: isValid ? "" : errorMessage,
  };
};

export const email = (value) =>{
  const hasError = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/.test(
    value
  );
  return {
    hasError: hasError,
    errorMessage: hasError
      ? "ایمیل نامعتبر است"
      : "",
  };
}
  

export const isNumber = (value) => {
  if (typeof value === "undefined" || value === "") {
    return {
      hasError: false,
      errorMessage: "وارد کردن مقدار برای این فیلد اجباری است",
    };
  }
  const hasError = !(/\D/.test(value));
  return {
    hasError: hasError,
    errorMessage: /\D/.test(value)
      ? "فقط مجاز به وارد کردن عدد و استفاده از اعداد صحیح هستید"
      : "",
  };
}

export const isFloat = (value) => {
  if (typeof value === "undefined" || value === "") {
    return {
      hasError: false,
      errorMessage: "وارد کردن مقدار برای این فیلد اجباری است",
    };
  }
  // const hasError = !(/^-?\d*(\.\d+)?$/.test(value));
  const hasError = (/^[-+]?\d+(\.)*?(\d+)*?$/.test(value));
  return {
    hasError: hasError,
    errorMessage: !(/^-?\d*(\.\d+)?$/.test(value))
      ? "فقط مجاز به وارد کردن عدد و استفاده از اعداد اعشاری هستید"
      : "",
  };
}